/**
 * Resovia "antenne"-logoet fra splash-animationen (statisk udgave).
 * Med signal-beam og cirkulær ring-forbindelse omkring top-noden.
 * tone="dark" = mørkegrønne streger til lyse baggrunde
 * tone="light" = lysegrønne streger til mørke baggrunde (som i splash)
 */
export default function ResoviaLogo({ className = "w-10 h-10", tone = "dark" }) {
  const stroke = tone === "dark" ? "#5B8C2A" : "#86efac";
  const node = tone === "dark" ? "#88C057" : "#bbf7d0";
  const nodeStroke = tone === "dark" ? "#F0EBE3" : "#ffffff";
  const beam = tone === "dark" ? "#88C057" : "#86efac";
  return (
    <svg viewBox="0 0 200 200" className={className} aria-label="Resovia logo">
      {/* Signal-beam: broadcast-buer over top-noden */}
      <path d="M 81 49 A 22 22 0 0 1 119 49" stroke={beam} strokeWidth="4" strokeLinecap="round" fill="none" opacity="0.65" />
      <path d="M 70.6 43 A 34 34 0 0 1 129.4 43" stroke={beam} strokeWidth="3.5" strokeLinecap="round" fill="none" opacity="0.4" />
      {/* Cirkulær ring-forbindelse omkring top-noden */}
      <circle cx="100" cy="60" r="21" fill="none" stroke={beam} strokeWidth="2.5" opacity="0.5" />
      {/* Stamme */}
      <line x1="100" y1="175" x2="100" y2="120" stroke={stroke} strokeWidth="9" strokeLinecap="round" />
      {/* 3 grene */}
      <path d="M 100 120 Q 100 90 100 60" stroke={stroke} strokeWidth="7" strokeLinecap="round" fill="none" />
      <path d="M 100 120 Q 80 110 60 92" stroke={stroke} strokeWidth="7" strokeLinecap="round" fill="none" />
      <path d="M 100 120 Q 120 110 140 92" stroke={stroke} strokeWidth="7" strokeLinecap="round" fill="none" />
      {/* Flow-linjer mellem noderne */}
      <path d="M 100 60 Q 130 70 140 92" stroke={node} strokeWidth="2.5" strokeLinecap="round" strokeDasharray="4 5" fill="none" opacity="0.7" />
      <path d="M 140 92 Q 100 110 60 92" stroke={node} strokeWidth="2.5" strokeLinecap="round" strokeDasharray="4 5" fill="none" opacity="0.7" />
      <path d="M 60 92 Q 70 70 100 60" stroke={node} strokeWidth="2.5" strokeLinecap="round" strokeDasharray="4 5" fill="none" opacity="0.7" />
      {/* 3 krone-noder */}
      <circle cx="100" cy="60" r="14" fill={node} stroke={nodeStroke} strokeWidth="2.5" />
      <circle cx="60" cy="92" r="14" fill={node} stroke={nodeStroke} strokeWidth="2.5" />
      <circle cx="140" cy="92" r="14" fill={node} stroke={nodeStroke} strokeWidth="2.5" />
    </svg>
  );
}
